export default function twFocusClass(hasRing = false) {
  if (!hasRing) {
    return "focus:outline-none";
  }
  return "focus:outline-none focus:ring-1 focus:ring-offset-0 focus:ring-gray-600 dark:focus:ring-white dark:focus:ring-offset-0";
}
